import { render, staticRenderFns } from "./InitTwo.vue?vue&type=template&id=7f0c4cd6&scoped=true&"
import script from "./InitTwo.vue?vue&type=script&lang=js&"
export * from "./InitTwo.vue?vue&type=script&lang=js&"
import style0 from "./InitTwo.vue?vue&type=style&index=0&id=7f0c4cd6&rel=stylesheet%2Fscss&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c4cd6",
  null
  
)

export default component.exports